<template>
  <div class="bto-sb-widget bto-sb-widget-category-nav">
    <div class="bto-sb-widget-content">
      <ul>
        <!-- eslint-disable -->
        <li
          v-for="(tab, idx) in tabs"
          :key="idx"
          v-if="tab.value"
          :class="{
            'bto-sb-category-nav-active': selectedTab === idx,
            'bto-sb-category-nav-flag': tab.class !== undefined,
          }"
        >
          <span v-if="tab.class" class="bto-sb-flag bto-sb-flag-oval" :class="tab.class"></span>
          <a
            v-if="tab.type === 'text'"
            href="javascript:void(0);"
            @click="selectTab(idx)"
          >
            {{tab.value}}
          </a>
          <div
            v-if="tab.type === 'select'"
            class="bto-sb-form-select"
          >
            <select @change="selectTab(idx, Number.parseInt($event.target.value, 10))">
              <option selected disabled v-if="selectedTab !== idx">
                {{t('W.FilterD')}}
              </option>
              <option
                v-for="(option, idx) in tab.value"
                :key="idx"
                :value="idx"
              >
                {{option}}
              </option>
            </select>
            <div class="bto-sb-form-select-arrow"></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CategoryNavComponent',
    props: {
      tabs: {
        type: Array,
        required: true,
        default: () => [],
      },
      selectedTab: {
        type: Number,
        required: true,
        default: 0,
      },
    },
    methods: {
      selectTab(tabIdx, optionIdx) {
        if (tabIdx === this.selectedTab && optionIdx === undefined) {
          return;
        }

        this.$emit('tabSelected', { tabIdx: tabIdx, optionIdx: optionIdx });
      },
    },
  }
</script>
